var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import moment from 'moment-timezone';
import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import axiosHttp from '@/api';
import useRetry from "@/hooks/useRetry";
import { getSubdomain, loadWhiteLabels, objectToQueryString } from "@/utils";
import { tokenRefreshService } from '@/services/tokenRefresh';
export var SessionContext = createContext({
    token: null,
    user: null,
    zoomContext: {},
    organization: null,
    checkingToken: null,
    whiteLabel: null,
    subdomain: null,
    loginLoading: false,
    openUrl: function () { },
    setOrganization: function () { },
    onLogin: function () { },
    setRecallBot: function () { },
    setSelectedKnowledgeBase: function () { },
    setSelectedMeetingHelperInstance: function () { },
});
export function useSessionContext() {
    return useContext(SessionContext);
}
export var SessionContextProvider = function (_a) {
    var _b;
    var children = _a.children, uniquePrefix = _a.uniquePrefix;
    var retry = useRetry().retry;
    var isServerRef = useRef(typeof window === 'undefined');
    var zoomSdkRef = useRef(null);
    var _c = useState(true), checkingToken = _c[0], setCheckingToken = _c[1];
    var isLocalhost = useState(window.location.hostname === 'localhost')[0];
    var _d = useState(false), loginLoading = _d[0], setLoginLoading = _d[1];
    var _e = useState(null), organization = _e[0], setOrganization = _e[1];
    var _f = useState(null), subdomain = _f[0], setSubdomain = _f[1];
    var _g = useState(null), token = _g[0], setToken = _g[1];
    var _h = useState(null), user = _h[0], setUser = _h[1];
    var _j = useState(null), whiteLabel = _j[0], setWhiteLabel = _j[1];
    var _k = useState({}), zoomContext = _k[0], setZoomContext = _k[1];
    var _l = useState(null), configError = _l[0], setConfigError = _l[1];
    var _m = useState(false), zoomSdkTimeout = _m[0], setZoomSdkTimeout = _m[1];
    var hostCheckIntervalRef = useRef(null);
    useEffect(function () {
        var initializeToken = function () { return __awaiter(void 0, void 0, void 0, function () {
            var token, refreshToken, decode, newToken, newDecode, xDomain, organization_1, error_1, decodedToken, xDomain, organization_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCheckingToken(true);
                        token = localStorage.getItem("token");
                        refreshToken = localStorage.getItem("refresh_token");
                        if (!token) return [3 /*break*/, 8];
                        decode = jwtDecode(token);
                        if (!(moment().unix() >= decode.exp)) return [3 /*break*/, 7];
                        if (!(refreshToken && tokenRefreshService.hasValidRefreshToken())) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        console.log('Token expired on startup, attempting refresh...');
                        return [4 /*yield*/, tokenRefreshService.refreshToken()];
                    case 2:
                        newToken = _a.sent();
                        newDecode = jwtDecode(newToken);
                        // Set up organization from new token
                        if (newDecode) {
                            xDomain = newDecode['x-domain'];
                            organization_1 = 'https://www.hitwit.ai';
                            if (xDomain) {
                                localStorage.setItem("organization", xDomain);
                                if (xDomain !== 'Hitwit-Public') {
                                    organization_1 = "https://".concat(xDomain, ".hitwit.ai");
                                }
                                handleSetOrganization(organization_1);
                            }
                        }
                        setToken(newToken);
                        setUser(newDecode);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to refresh token on startup:', error_1);
                        // Clear tokens and redirect to login
                        tokenRefreshService.clearTokens();
                        setToken(null);
                        setUser(null);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        // No refresh token available, clear everything
                        localStorage.removeItem("token");
                        setToken(null);
                        setUser(null);
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        decodedToken = jwtDecode(token);
                        if (decodedToken) {
                            xDomain = decodedToken['x-domain'];
                            organization_2 = 'https://www.hitwit.ai';
                            if (xDomain) {
                                localStorage.setItem("organization", xDomain);
                                if (xDomain !== 'Hitwit-Public') {
                                    organization_2 = "https://".concat(xDomain, ".hitwit.ai");
                                }
                                handleSetOrganization(organization_2);
                            }
                        }
                        setToken(token);
                        setUser(decode);
                        _a.label = 8;
                    case 8:
                        // Initialize token refresh service
                        tokenRefreshService.initialize();
                        setCheckingToken(false);
                        return [2 /*return*/];
                }
            });
        }); };
        initializeToken();
    }, []);
    useEffect(function () {
        var _a, _b;
        setConfigError(null);
        if (token) {
            axiosHttp.get("admin/?".concat(objectToQueryString(__assign({ action: "common_meeting_helper_get_tool_config", meeting_type: 'zoom' }, (((_a = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _a === void 0 ? void 0 : _a.id) ? { meeting_id: (_b = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _b === void 0 ? void 0 : _b.id } : {})))))
                .then(function (res) {
                var _a;
                console.log("common_meeting_helper_get_tool_config response:", res === null || res === void 0 ? void 0 : res.data);
                if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.tool_config) {
                    setZoomContext(function (prev) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                        var newContext = __assign(__assign({}, prev), { default_bot_name: (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.tool_config) === null || _b === void 0 ? void 0 : _b.bot_name, default_knowledge_base_id: (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.tool_config) === null || _d === void 0 ? void 0 : _d.default_knowledge_base_id, selected_knowledge_base_id: ((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.active_meeting) && ((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.active_meeting) === null || _g === void 0 ? void 0 : _g.knowledge_base_id) ? (_j = (_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.active_meeting) === null || _j === void 0 ? void 0 : _j.knowledge_base_id :
                                (_l = (_k = res === null || res === void 0 ? void 0 : res.data) === null || _k === void 0 ? void 0 : _k.tool_config) === null || _l === void 0 ? void 0 : _l.default_knowledge_base_id, default_meeting_helper_instance_id: (_o = (_m = res === null || res === void 0 ? void 0 : res.data) === null || _m === void 0 ? void 0 : _m.tool_config) === null || _o === void 0 ? void 0 : _o.default_meeting_helper_instance_id, selected_meeting_helper_instance_id: ((_p = res === null || res === void 0 ? void 0 : res.data) === null || _p === void 0 ? void 0 : _p.active_meeting) && ((_r = (_q = res === null || res === void 0 ? void 0 : res.data) === null || _q === void 0 ? void 0 : _q.active_meeting) === null || _r === void 0 ? void 0 : _r.meeting_helper_instance_id) ? (_t = (_s = res === null || res === void 0 ? void 0 : res.data) === null || _s === void 0 ? void 0 : _s.active_meeting) === null || _t === void 0 ? void 0 : _t.meeting_helper_instance_id :
                                (_v = (_u = res === null || res === void 0 ? void 0 : res.data) === null || _u === void 0 ? void 0 : _u.tool_config) === null || _v === void 0 ? void 0 : _v.default_meeting_helper_instance_id, hasAccess: true });
                        console.log("Setting zoom context:", newContext);
                        return newContext;
                    });
                }
                else {
                    setConfigError("Zoom is unavailable for this organization. Please contact your administrator.");
                }
            })
                .catch(function (e) {
                var _a, _b, _c, _d;
                console.log("error", e);
                if ((e === null || e === void 0 ? void 0 : e.status) === 400) {
                    var message = ((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || ((_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reason) || "Something went wrong. Please contact your administrator.";
                    setConfigError(message);
                }
            });
        }
    }, [token, (_b = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _b === void 0 ? void 0 : _b.id]);
    var handleZoomAction = function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("context", context);
            return [2 /*return*/];
        });
    }); };
    var checkIfUserIsMeetingHost = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var meetingJoinUrl, isHost_1, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ((_a = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _a === void 0 ? void 0 : _a.getMeetingJoinUrl())];
                case 2:
                    meetingJoinUrl = _b.sent();
                    isHost_1 = meetingJoinUrl ? true : false;
                    // Update state if host status changed
                    if (isHost_1 !== (zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.canInviteBot)) {
                        setZoomContext(function (prev) { return (__assign(__assign({}, prev), { canInviteBot: isHost_1 })); });
                    }
                    return [2 /*return*/, isHost_1];
                case 3:
                    e_1 = _b.sent();
                    console.error("Error checking host status:", e_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/, false];
            }
        });
    }); }, [zoomContext]);
    // Add this function to start the interval
    var startHostCheckInterval = useCallback(function () {
        // Clear any existing interval first
        if (hostCheckIntervalRef.current) {
            clearInterval(hostCheckIntervalRef.current);
        }
        // Set up a new interval (checking every 5 seconds)
        hostCheckIntervalRef.current = setInterval(function () {
            checkIfUserIsMeetingHost();
        }, 5000); // 5000ms = 5 seconds
        // Initial check
        checkIfUserIsMeetingHost();
    }, [checkIfUserIsMeetingHost]);
    // Add this to clean up the interval when unmounting
    useEffect(function () {
        return function () {
            if (hostCheckIntervalRef.current) {
                clearInterval(hostCheckIntervalRef.current);
            }
            // Clean up token refresh service
            tokenRefreshService.cleanup();
        };
    }, []);
    var initializeZoomSdk = function () { return __awaiter(void 0, void 0, void 0, function () {
        var runningContext_1, meetingContext_1, meetingJoinUrl_1, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (isServerRef.current)
                        return [2 /*return*/];
                    return [4 /*yield*/, new Promise(function (resolve) {
                            if (window.zoomSdk) {
                                resolve();
                            }
                            else {
                                document.addEventListener('ZoomSDKLoaded', function () { return resolve(); });
                            }
                        })];
                case 1:
                    _f.sent();
                    zoomSdkRef.current = window.zoomSdk;
                    _f.label = 2;
                case 2:
                    _f.trys.push([2, 9, , 10]);
                    return [4 /*yield*/, ((_a = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _a === void 0 ? void 0 : _a.config({
                            capabilities: [
                                'openUrl',
                                'getRunningContext',
                                'getMeetingContext',
                                'getMeetingJoinUrl',
                                'shareApp',
                                'onParticipantChange'
                            ],
                            version: '0.16.24',
                            popoutSize: { width: 480, height: 720 },
                            size: { width: 480, height: 720 }
                        }))];
                case 3:
                    _f.sent();
                    console.log('Zoom SDK initialized with required permissions');
                    return [4 /*yield*/, ((_b = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _b === void 0 ? void 0 : _b.getRunningContext())];
                case 4:
                    runningContext_1 = _f.sent();
                    console.log("runningContext", runningContext_1);
                    setZoomContext(function (prev) {
                        return __assign(__assign({}, prev), { context: runningContext_1 === null || runningContext_1 === void 0 ? void 0 : runningContext_1.context });
                    });
                    if (!(runningContext_1.context === 'inMeeting')) return [3 /*break*/, 7];
                    console.log('App is running in a meeting');
                    return [4 /*yield*/, ((_c = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _c === void 0 ? void 0 : _c.getMeetingContext())];
                case 5:
                    meetingContext_1 = _f.sent();
                    console.log(meetingContext_1);
                    return [4 /*yield*/, ((_d = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _d === void 0 ? void 0 : _d.getMeetingJoinUrl())];
                case 6:
                    meetingJoinUrl_1 = _f.sent();
                    setZoomContext(function (prev) {
                        return __assign(__assign(__assign({}, prev), meetingContext_1), { joinUrl: meetingJoinUrl_1 === null || meetingJoinUrl_1 === void 0 ? void 0 : meetingJoinUrl_1.joinUrl, canInviteBot: true });
                    });
                    return [3 /*break*/, 8];
                case 7:
                    // App is running outside of a meeting
                    console.log('App is not in a meeting context');
                    _f.label = 8;
                case 8:
                    (_e = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _e === void 0 ? void 0 : _e.onParticipantChange(function (event) {
                        console.log("event", event);
                        //checkIfUserIsMeetingHost();
                        setZoomContext(function (prev) {
                            return __assign(__assign({}, prev), { participants: event.participants });
                        });
                    });
                    return [3 /*break*/, 10];
                case 9:
                    error_2 = _f.sent();
                    console.error('Failed to initialize Zoom SDK:', error_2);
                    setZoomContext(function (prev) {
                        return __assign(__assign({}, prev), { canInviteBot: false });
                    });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        initializeZoomSdk();
        // Set a timeout to prevent infinite loading if Zoom SDK fails
        var timeoutId = setTimeout(function () {
            if (!(zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.context)) {
                console.log("Zoom SDK initialization timeout - allowing app to load");
                setZoomSdkTimeout(true);
            }
        }, 10000); // 10 second timeout
        return function () { return clearTimeout(timeoutId); };
    }, []);
    var getWhiteLabel = function (subdomain) { return __awaiter(void 0, void 0, void 0, function () {
        var domains, response;
        var _a;
        var _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!subdomain || subdomain === "")
                        return [2 /*return*/, loadWhiteLabels()["www.hitwit.ai"]];
                    domains = {};
                    return [4 /*yield*/, axiosHttp.get("?".concat(objectToQueryString({ domain_name: subdomain, user_timezone: moment.tz.guess(), action: 'get_domain_config' })), {
                            headers: __assign({}, (subdomain ? { 'X-Domain': subdomain } : {}))
                        })];
                case 1:
                    response = _j.sent();
                    if (response && (response === null || response === void 0 ? void 0 : response.data) && ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.domain_config)) {
                        if ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.domain_config) === null || _d === void 0 ? void 0 : _d.ui_options) {
                            domains = (_a = {}, _a[subdomain] = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.domain_config) === null || _f === void 0 ? void 0 : _f.ui_options, _a);
                        }
                        if ((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.domain_config) === null || _h === void 0 ? void 0 : _h.tool_config) {
                            setZoomContext(function (prev) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                                return __assign(__assign({}, prev), { default_bot_name: (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.domain_config) === null || _b === void 0 ? void 0 : _b.tool_config) === null || _c === void 0 ? void 0 : _c.bot_name, default_knowledge_base_id: (_f = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.domain_config) === null || _e === void 0 ? void 0 : _e.tool_config) === null || _f === void 0 ? void 0 : _f.default_knowledge_base_id, selected_knowledge_base_id: (_j = (_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.domain_config) === null || _h === void 0 ? void 0 : _h.tool_config) === null || _j === void 0 ? void 0 : _j.default_knowledge_base_id, default_meeting_helper_instance_id: (_m = (_l = (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.domain_config) === null || _l === void 0 ? void 0 : _l.tool_config) === null || _m === void 0 ? void 0 : _m.default_meeting_helper_instance_id, selected_meeting_helper_instance_id: (_q = (_p = (_o = response === null || response === void 0 ? void 0 : response.data) === null || _o === void 0 ? void 0 : _o.domain_config) === null || _p === void 0 ? void 0 : _p.tool_config) === null || _q === void 0 ? void 0 : _q.default_meeting_helper_instance_id });
                            });
                        }
                        return [2 /*return*/, loadWhiteLabels(domains)[subdomain]];
                    }
                    return [2 /*return*/, loadWhiteLabels()["www.hitwit.ai"]];
            }
        });
    }); };
    var handleSetOrganization = function (organization) { return __awaiter(void 0, void 0, void 0, function () {
        var subdomain, whiteLabel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOrganization(organization);
                    localStorage.setItem("organization", organization);
                    subdomain = getSubdomain(organization);
                    setSubdomain(subdomain);
                    return [4 /*yield*/, getWhiteLabel(subdomain)];
                case 1:
                    whiteLabel = _a.sent();
                    console.log("whiteLabel", whiteLabel);
                    setWhiteLabel(whiteLabel);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetMeetingBot = function (bot) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setZoomContext(function (prev) {
                return __assign(__assign({}, prev), { recallBot: bot });
            });
            return [2 /*return*/];
        });
    }); };
    // TODO: Remove this
    var handleSetSelectedKnowledgeBase = useCallback(function (value) {
        var _a, _b;
        if (value) {
            if ((_a = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _a === void 0 ? void 0 : _a.id) {
                axiosHttp.post("admin?".concat(objectToQueryString({
                    action: "set_current_zoom_meeting_knowledge_base",
                    meeting_type: 'zoom',
                })), {
                    meeting_id: (_b = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _b === void 0 ? void 0 : _b.id,
                    knowledge_base_id: value
                })
                    .then(function (res) {
                    setZoomContext(function (prev) {
                        return __assign(__assign({}, prev), { selected_knowledge_base_id: value });
                    });
                });
            }
            else {
                setZoomContext(function (prev) {
                    return __assign(__assign({}, prev), { selected_knowledge_base_id: value });
                });
            }
        }
        else {
            setZoomContext(function (prev) {
                return __assign(__assign({}, prev), { selected_knowledge_base_id: value });
            });
        }
    }, [zoomContext]);
    var handleSetSelectedMeetingHelperInstance = useCallback(function (value) {
        var _a, _b;
        if (value) {
            if ((_a = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _a === void 0 ? void 0 : _a.id) {
                axiosHttp.post("admin?".concat(objectToQueryString({ action: "meeting_helper_set_instance_for_meeting", meeting_type: 'zoom' })), {
                    meeting_id: (_b = zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.recallBot) === null || _b === void 0 ? void 0 : _b.id,
                    meeting_helper_instance_id: value
                })
                    .then(function (res) {
                    setZoomContext(function (prev) {
                        return __assign(__assign({}, prev), { selected_meeting_helper_instance_id: value });
                    });
                });
            }
            else {
                setZoomContext(function (prev) {
                    return __assign(__assign({}, prev), { selected_meeting_helper_instance_id: value });
                });
            }
        }
        else {
            setZoomContext(function (prev) {
                return __assign(__assign({}, prev), { selected_meeting_helper_instance_id: value });
            });
        }
    }, [zoomContext]);
    var onLogout = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (logoutFromZoom) {
            if (logoutFromZoom === void 0) { logoutFromZoom = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!logoutFromZoom) return [3 /*break*/, 2];
                        return [4 /*yield*/, axiosHttp.get("?".concat(objectToQueryString({ action: 'logout' })))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Clean up token refresh service
                        tokenRefreshService.cleanup();
                        setToken(null);
                        setUser(null);
                        setOrganization(null);
                        setSubdomain(null);
                        setWhiteLabel(null);
                        setZoomContext({});
                        // Clear all tokens
                        tokenRefreshService.clearTokens();
                        return [2 /*return*/];
                }
            });
        });
    };
    var pollForAccessToken = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            //@ts-ignore
            return [2 /*return*/, axios.get("".concat(process.env.REACT_APP_API_URL, "/?").concat(objectToQueryString({ action: "zoom_get_token_exchange_code", code: code })))
                    .then(function (res) {
                    var _a, _b, _c, _d, _e, _f;
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.access_token) && ((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.refresh_token)) {
                        var decodedToken = jwtDecode((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.access_token);
                        if (decodedToken) {
                            var xDomain = decodedToken['x-domain'];
                            var organization_3 = 'https://www.hitwit.ai';
                            if (xDomain) {
                                localStorage.setItem("organization", xDomain);
                                if (xDomain !== 'Hitwit-Public') {
                                    organization_3 = "https://".concat(xDomain, ".hitwit.ai");
                                }
                                handleSetOrganization(organization_3);
                            }
                        }
                        localStorage.setItem("token", (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.access_token);
                        localStorage.setItem("refresh_token", (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.refresh_token);
                        // Initialize token refresh service with new tokens
                        tokenRefreshService.initialize();
                        return (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.access_token;
                    }
                    throw new Error("waiting for token..");
                })
                    .catch(function (e) {
                    console.log(e);
                    throw e;
                })];
        });
    }); };
    var onLogin = function (connection, email) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoginLoading(true);
            //@ts-ignore
            axios.get("".concat(process.env.REACT_APP_API_URL, "/?").concat(objectToQueryString({
                action: "zoom_create_token_exchange_code"
            })))
                .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                var code, redirectUrl, loginUrl, result, token_1, error_3;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            code = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.state;
                            redirectUrl = "".concat(window.location.origin, "/auth-callback/").concat(code);
                            loginUrl = "https://www.".concat(process.env.NODE_ENV === 'development' ? 'test.' : '', "hitwit.ai/login?redirect=").concat(encodeURIComponent(redirectUrl));
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, ((_b = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _b === void 0 ? void 0 : _b.openUrl({
                                    url: loginUrl,
                                }))];
                        case 2:
                            result = _c.sent();
                            console.log('Auth window opened:', result);
                            return [4 /*yield*/, retry(function () { return pollForAccessToken(code); }, function () { return console.log('Retrying...'); }, 100, 5, function () { return true; })];
                        case 3:
                            token_1 = _c.sent();
                            if (token_1) {
                                window.location.reload();
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            error_3 = _c.sent();
                            setLoginLoading(false);
                            console.error('Failed to open auth window:', error_3);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                console.log("e", e);
            });
            return [2 /*return*/];
        });
    }); };
    var openUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ((_a = zoomSdkRef === null || zoomSdkRef === void 0 ? void 0 : zoomSdkRef.current) === null || _a === void 0 ? void 0 : _a.openUrl({
                        url: url,
                    }))];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var contextProvider = {
        openUrl: openUrl,
        token: token,
        user: user,
        zoomContext: zoomContext,
        organization: organization,
        uniquePrefix: uniquePrefix,
        checkingToken: checkingToken,
        whiteLabel: whiteLabel,
        subdomain: subdomain,
        loginLoading: loginLoading,
        onLogin: onLogin,
        onLogout: onLogout,
        setOrganization: handleSetOrganization,
        setRecallBot: handleSetMeetingBot,
        setSelectedKnowledgeBase: handleSetSelectedKnowledgeBase,
        setSelectedMeetingHelperInstance: handleSetSelectedMeetingHelperInstance,
    };
    return (_jsx(SessionContext.Provider, { value: contextProvider, children: !isLocalhost ?
            (function () {
                var shouldShowLoading = checkingToken || configError || (token && !(zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.context) && !(zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.hasAccess) && !zoomSdkTimeout);
                console.log("Loading condition check:", {
                    checkingToken: checkingToken,
                    configError: configError,
                    token: !!token,
                    hasAccess: zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.hasAccess,
                    context: zoomContext === null || zoomContext === void 0 ? void 0 : zoomContext.context,
                    zoomSdkTimeout: zoomSdkTimeout,
                    shouldShowLoading: shouldShowLoading
                });
                return shouldShowLoading;
            })()
                ? _jsx(Box, { sx: { height: '100%', mt: 3 }, children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: _jsxs(Box, { sx: { height: "100vh", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }, children: [_jsx("img", { style: { marginTop: 4, marginBottom: 4, maxWidth: 250, height: 250, objectFit: 'contain' }, src: require("@/static/login.svg") }), !configError && _jsx(CircularProgress, { size: 48 }), configError && _jsx(Typography, { sx: { my: 2, textAlign: 'center' }, variant: "h6", children: configError }), !configError && _jsx(Typography, { sx: { mt: 2, textAlign: 'center' }, variant: "h6", children: "Loading.." }), configError && _jsx(Button, { onClick: function () { return onLogout(true); }, sx: { mt: 2 }, variant: "contained", children: "Try Again" })] }) }) })
                : children
            : children }));
};
